<div class="pr-2 pl-2">
	<div class="row mt-2">
		<div class="col-sm-12 br-input" [ngClass]="{'danger': erroNomeCargo && submetido}">
			<label for="nomeCampo">Nome do cargo (Obrigatório):</label>
			<input
				#elNomeCampo
				id="nomeCampo"
				name="nomeCampo"
				pInputText
				type="text"
				data-cy="campo-texto-nome"
				[(ngModel)]="item.nomeCargo"
				[ngModelOptions]="{standalone: true}"
				maxlength="140"
				minlength="3"
			/>
			<sgp-message-feedback [show]="erroNomeCargo" [mensagem]="mensagemErroNome" data-cy="erro-nome-campo"></sgp-message-feedback>
		</div>
	</div>
	<div class="row mt-2">
		<div class="col-sm-6 mt-2 br-input" [ngClass]="{'danger': erroCodigoCargo && submetido}">
			<label for="campo-codigo-cargo">Código do cargo (Obrigatório):</label>
			<input
				onlyNumbers
				type="text"
				[(ngModel)]="codigoCargoStr"
				[ngModelOptions]="{standalone: true}"
				maxlength="6"
				inputId="campo-codigo-cargo"
				(blur)="formatarCodigoCargo()"
				inputmode="numeric"
				pattern="[0-9]*"
				data-cy="campo-codigo-cargo"
				placeholder="Informe o código do cargo"
			/>
			<sgp-message-feedback
				[show]="erroCodigoCargo"
				[mensagem]="mensagemErroCodigoCargo"
				data-cy="erro-codigo-cargo"
			></sgp-message-feedback>
		</div>
	</div>
	<div class="row mt-2">
		<div class="col-sm-12 br-input" [ngClass]="{'danger': erroConcurso && submetido}">
			<label for="campo-concurso">Concurso (Obrigatório):</label>
			<p-dropdown
				[options]="concursos"
				(onChange)="selecionarConcurso($event)"
				[(ngModel)]="item.idConcurso"
				[ngModelOptions]="{standalone: true}"
				placeholder="Selecione o concurso"
				appendTo="body"
				id="campo-concurso"
				data-cy="campo-concurso"
			></p-dropdown>
			<sgp-message-feedback
				[show]="erroConcurso"
				[mensagem]="mensagemErroConcurso"
				data-cy="erro-concurso-obrigatorio"
			></sgp-message-feedback>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 mt-2 br-input" [ngClass]="{'danger': erroOrgao && submetido}">
			<sgp-busca-orgao
				id="idOrgaos"
				inputId="idOrgaos"
				label="Órgão (Obrigatório):"
				name="orgaoSelecionado"
				[ngModel]="orgaoSelecionado"
				ngDefaultControl
				(ngModelUpdated)="atualizarOrgao($event)"
				[exibirCodigoNaDescricao]="true"
				data-cy="campo-orgao"
			></sgp-busca-orgao>
			<sgp-message-feedback [show]="erroOrgao" [mensagem]="mensagemErroOrgao" data-cy="erro-orgao-obrigatorio"></sgp-message-feedback>
		</div>
	</div>
	<div class="row mt-4 mb-4">
		<div class="col-sm-12 text-right">
			<button pButton data-cy="btnCancelar" class="secondary mr-2" (click)="cancelar()">Cancelar</button>
			<button id="btnSalvar" data-cy="botao-salvar" class="primary" (click)="salvar()" type="submit" pButton>Salvar</button>
		</div>
	</div>
</div>
